import {Action} from 'redux'
import {SubsidiaryCategoryModel} from '../Model/SubsidiaryCategoryModel'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialSubsidiaryCategoryState: ISubsidiaryCategoryState = {
  data: {
    subsidiaryCategory: [],
    meta: [],
  },
  sortSubsidiaryCategoryData: [],
  subsidiaryCategoryList: {subsidiaryCategory: []},
  deleteSuccess: false,
  enableSuccess: false,
  disableSuccess: false,
  singleEnableSuccess: false,
  singleDisableSuccess: false,
  loading: false,
  success: false,
}

export interface ISubsidiaryCategoryState {
  data?: {
    subsidiaryCategory?: SubsidiaryCategoryModel[]
    meta?: {[key: string]: string | number}[]
  }
  sortSubsidiaryCategoryData?: ISubsidiaryCategoryState[]
  subsidiaryCategoryList?: {subsidiaryCategory: SubsidiaryCategoryModel[]}
  deleteSuccess?: boolean
  enableSuccess?: boolean
  disableSuccess?: boolean
  singleEnableSuccess?: boolean
  singleDisableSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ISubsidiaryCategoryState = initialSubsidiaryCategoryState,
  action: ActionWithPayload<ISubsidiaryCategoryState>
) => {
  switch (action.type) {
    case actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action.payload,
        subsidiaryCategoryList: action.payload,
        loading: false,
      }
    }

    case actionTypes.GET_ALL_SUBSIDIARY_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //GET SubsidiaryCategory DATA
    case actionTypes.GET_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_SUBSIDIARY_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Add SubsidiaryCategory
    case actionTypes.ADD_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_SUBSIDIARY_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.RESET_SUBSIDIARY_CATEGORY: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    //Update SubsidiaryCategory
    case actionTypes.UPDATE_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: action?.payload?.data,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_SUBSIDIARY_CATEGORY_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    //Delete
    case actionTypes.DELETE_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    //Enable
    case actionTypes.ENABLE_SUBSIDIARY_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.ENABLE_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        enableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.ENABLE_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        enableSuccess: false,
      }
    }

    //disable
    case actionTypes.DISABLE_SUBSIDIARY_CATEGORY_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.DISABLE_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        disableSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DISABLE_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        disableSuccess: false,
      }
    }
    //Enable
    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.subsidiaryCategory
      let newData = state?.data?.subsidiaryCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })
      return {
        ...state,
        data: {...state, meta: state?.data?.meta, subsidiaryCategory: newData},
        singleEnableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_ENABLE_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        singleEnableSuccess: false,
        toggleLoading: false,
      }
    }

    //Disable
    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_REQUEST: {
      return {...state, toggleLoading: true}
    }

    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_SUCCESS: {
      const changedData: any = action.payload?.data?.subsidiaryCategory
      let newData = state?.data?.subsidiaryCategory?.map((data) => {
        if (data?.id === changedData[0]?.id) {
          return {
            ...data,
            status: !data?.status,
          }
        } else {
          return data
        }
      })

      return {
        ...state,
        data: {...state, meta: state?.data?.meta, subsidiaryCategory: newData},
        singleDisableSuccess: true,
        toggleLoading: false,
      }
    }

    case actionTypes.SINGLE_DISABLE_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        singleDisableSuccess: false,
        toggleLoading: false,
      }
    }

    // sort
    case actionTypes.SORT_SUBSIDIARY_CATEGORY_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_SUBSIDIARY_CATEGORY_SUCCESS: {
      return {
        ...state,
        sortSubsidiaryCategoryData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_SUBSIDIARY_CATEGORY_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_SUBSIDIARY_CATEGORY_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortSubsidiaryCategoryData: [],
      }
    }

    default:
      return state
  }
}
